var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:{bordered: _vm.bordered},style:(_vm.style)},[_c('img',{attrs:{"alt":_vm.alt,"src":_vm.image,"draggable":"false"},on:{"error":_vm.onError}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }